import { Helmet } from "react-helmet-async";
import Screen from "./Layouts/Screen/Screen";
import ItemList from "../components/ItemList/ItemList";
import { getAppLastVersion, getAppVersion, getLinkStore, hasNewVersion } from "../utils/platform";

const AppVersion = () => {
  const newVersion = hasNewVersion();
  const appVersion = getAppVersion();
  const lastAppVersion = getAppLastVersion();
  const linkStore = getLinkStore();

  return (
    <>
      <Screen paddingTopTitle={true} title="Versão do sistema">
        <Helmet>
          <title>Paçoca - Versão do Aplicativo</title>
          <meta name="description" content={`Paçoca - Versão do Aplicativo!`} />
          <meta name="keywords" content={`Paçoca, rede social brasileira, Versão do Aplicativo, selos, badges, sobre}`} />
          <meta name="author" content="Paçoca Inc." />
          <meta property="og:title" content={`Paçoca - Versão do Aplicativo - Rede Social`} />
          <meta property="og:description" content={`Paçoca - Versão do Aplicativo`} />
          <meta property="og:image" content="/img/link-preview.png?v=1" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={`Paçoca - Versão do Aplicativo - Rede Social`} />
          <meta name="twitter:description" content={`Paçoca - Versão do Aplicativo`} />
          <meta name="twitter:image" content="/img/link-preview.png?v=1" />
        </Helmet>

        <p className="text-center" style={{ marginTop: 30, marginBottom: 0 }}>
          Versão do seu APP: {appVersion}
        </p>
        
        <p className="text-center" style={{ marginTop: 10, marginBottom: 0 }}>
          Última versão disponível: {appVersion && appVersion > lastAppVersion ? appVersion : lastAppVersion}
        </p>

        <p className="text-center" style={{ marginTop: 10, marginBottom: 0 }}>
          {!newVersion ? "Seu app está na última versão" : (
            <a target="_BLANK" href={linkStore} className="mt-5 btn btn-w-100 btn-blue">Baixar Atualização</a>
          )}
        </p>
      </Screen>
    </>
  );
};

export default AppVersion;
